import { palette } from '../../styles/tokens';

// ── Dispatch statuses ──
export const DISPATCH_STATUSES: Record<string, { label: string; color: string; bg: string }> = {
  new:       { label: 'Unassigned', color: palette.g500,    bg: palette.g100 },
  assigned:  { label: 'Dispatched', color: '#0F6CBD',       bg: '#E8F1FA' },
  en_route:  { label: 'En Route',   color: '#CA5010',       bg: '#FFF7ED' },
  on_site:   { label: 'On Site',    color: palette.green,    bg: palette.greenWash },
  completed: { label: 'Completed',  color: palette.green,    bg: palette.greenWash },
  cancelled: { label: 'Cancelled',  color: palette.red,      bg: palette.redWash },
};

export const ACTIVE_DISPATCH_STATUSES = ['assigned', 'en_route', 'on_site'];
export const QUEUE_STATUSES = ['new'];

export const STATUS_FLOW = ['new', 'assigned', 'en_route', 'on_site', 'completed'];

export function nextStatus(current: string): string | null {
  const idx = STATUS_FLOW.indexOf(current);
  return idx >= 0 && idx < STATUS_FLOW.length - 1 ? STATUS_FLOW[idx + 1] : null;
}

// ── Crew statuses ──
export const CREW_STATUSES: Record<string, { label: string; color: string; dot: string }> = {
  available: { label: 'Available', color: palette.green,    dot: '\u25CF' },
  on_job:    { label: 'On Job',    color: '#0F6CBD',       dot: '\u25CF' },
  en_route:  { label: 'En Route',  color: '#CA5010',       dot: '\u25CF' },
  scheduled: { label: 'Scheduled', color: palette.g500,    dot: '\u25CF' },
  off_today: { label: 'Off Today', color: palette.g300,    dot: '\u25CB' },
};

export const CREW_STATUS_ORDER = ['available', 'on_job', 'en_route', 'scheduled', 'off_today'];

// ── Priority styles ──
export const PRIORITY_STYLES: Record<string, { bg: string; fg: string; label: string }> = {
  high:   { bg: palette.redWash,   fg: palette.red,   label: 'HIGH' },
  medium: { bg: palette.amberWash, fg: palette.amber,  label: 'MED' },
  low:    { bg: palette.greenWash, fg: palette.green,  label: 'LOW' },
};

// ── Shared styles ──
export const CARD: React.CSSProperties = {
  padding: '10px 12px', borderRadius: 8, background: palette.white,
  border: `1px solid ${palette.g150}`, marginBottom: 6, cursor: 'pointer',
  transition: 'border-color 0.12s',
};

export const SECTION_LABEL: React.CSSProperties = {
  fontSize: 11, fontWeight: 600, color: palette.g400, textTransform: 'uppercase',
  letterSpacing: '0.06em', padding: '8px 0 4px',
};
